<template>
    <div>
        <!-- EC2优化建议 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="20" class="title">{{ $t('MCM.reportConfiguration.ec2OptimizeSuggestion') }}</Col>
                        <Col style="float: right;">
                            <Button @click="selectOptimizeListInstance" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_EC2']">{{ $t('MCM.reportConfiguration.add') }}</Button>
                        </Col>
                    </Row>
                    <!-- EC2优化建议 -->
                 	<Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="instance" :data="instanceDate" :loading="instanceLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDelete(index)">
			                    <Button type="error" size="small" @click="instanceDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_EC2']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                 	<!-- 优化建议 -->
                 	<Row :gutter="4" style="margin-top: 16px;">
                    	<Col span="20" style="font-size: 13px;margin-bottom: 5px;">{{ $t('MCM.reportConfiguration.optimizeSuggestion') }}</Col>
                        <Col span="24">
                            <Input v-model="ecdescription" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="margin-bottom: 10px;"></Input>
                        </Col>
                        <Col span="24">
                            <Button @click="updateInstanceOptimizeSuggestion" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:update_EC2']">{{ $t('MCM.reportConfiguration.update') }}</Button>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        <!-- RDS优化建议 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="20" class="title">{{ $t('MCM.reportConfiguration.rdsOptimizeSuggestion') }}</Col>
                        <Col style="float: right;">
                            <Button @click="selectOptimizeListRDS" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_RDS']">{{ $t('MCM.reportConfiguration.add') }}</Button>
                        </Col>
                    </Row>
                 	<!-- RDS优化建议 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="database" :data="databaseDate" :loading="databaseLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDeleteDatabase(index)">
			                    <Button type="error" size="small" @click="databaseDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_RDS']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                 	<!-- 优化建议 -->
                 	<Row :gutter="4" style="margin-top: 16px;">
                    	<Col span="20" style="font-size: 13px;margin-bottom: 5px;">{{ $t('MCM.reportConfiguration.optimizeSuggestion') }}</Col>
                        <Col span="24">
                            <Input v-model="rdsDescription" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="margin-bottom: 10px;"></Input>
                        </Col>
                        <Col span="24">
                            <Button @click="updateDatabaseOptimizeSuggestion" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:update_RDS']">{{ $t('MCM.reportConfiguration.update') }}</Button>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        <!-- 降级前后花费对比 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="20" class="title">{{ $t('MCM.reportConfiguration.costComparison') }}</Col>
                        <Col style="float: right;">
                            <Button @click="selectOptimizeListCostComparison" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_contrast_report']">{{ $t('MCM.reportConfiguration.add') }}</Button>
                        </Col>
                    </Row>
                 	<!-- 降级前后花费对比 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="costComparison" :data="costComparisonDate" :loading="costComparisonLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDeleteCostComparison(index)">
			                    <Button type="error" size="small" @click="costComparisonDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_contrast_report']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                </Card>
            </Col>
        </Row>
        <!-- 降级前后花费对比添加 -->
        <Modal v-model="costComparisonModal" :title="$t('MCM.reportConfiguration.add')" width="900px;" :loading="costComparisonModalLoading" :ok-text="$t('MCM.reportConfiguration.add')" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancelCostComparison()">{{ $t('MCM.reportConfiguration.cancel') }}</Button>
                <Button type="primary" @click="costComparisonHandleSubmit()" :loading="costComparisonAddloading" :disabled="costComparisonIsDisable">{{ $t('MCM.reportConfiguration.add') }}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" class="table-css" ref="selection" :columns="costComparisonColumns" :loading="costComparisonLoadingAdd" :data="queryCostComparisonData" :height="400" @on-selection-change="getSelectionCostComparison"></Table>
        </Modal>
        <!-- 降级前后花费对比删除 -->
        <Modal v-model="costComparisonDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{costComparisonName}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="costComparisonDelLoading" @click="removeCostComparison()" :disabled="isDisableCostComparison">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
        <!--分割线-->
        <!-- EC2优化建议添加 -->
        <Modal v-model="instanceModal" :title="$t('MCM.reportConfiguration.add')" width="900px;" :loading="modalLoading" :ok-text="$t('MCM.reportConfiguration.add')" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancel()">{{ $t('MCM.reportConfiguration.cancel') }}</Button>
                <Button type="primary" @click="handleSubmit()" :loading="addloading" :disabled="isDisable">{{ $t('MCM.reportConfiguration.add') }}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" class="table-css" ref="selection" :columns="columns" :loading="loading" :data="queryInstanceData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
        <!-- EC2优化建议删除 -->
        <Modal v-model="instanceDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{name}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeInstance()" :disabled="isDisableDelete">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
        <!--分割线-->
        <!-- RDS优化建议添加 -->
        <Modal v-model="databaseModal" :title="$t('MCM.reportConfiguration.add')" width="900px;" :loading="databaseModalLoading" :ok-text="$t('MCM.reportConfiguration.add')" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancelDatabase()">{{ $t('MCM.reportConfiguration.cancel') }}</Button>
                <Button type="primary" @click="databaseHandleSubmit()" :loading="databaseAddloading" :disabled="databaseIsDisable">{{ $t('MCM.reportConfiguration.add') }}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" class="table-css" ref="selection" :columns="databaseColumns" :loading="databaseLoadingAdd" :data="queryDatabaseData" :height="400" @on-selection-change="getSelectionDatabase"></Table>
        </Modal>
        <!-- RDS优化建议删除 -->
        <Modal v-model="databaseDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{databaseName}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="databaseDelLoading" @click="removeDatabase()" :disabled="isDisableDatabase">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    var resourceOptimizationVue = {}
    export default {
        name: 'ResourceOptimization',
        data(){
            return {
                optimizeTypeList:["升级","降级"],
                accountIdList:[],
                reportId:0,
                companyId:0,
                reportDate:'',  //初始化传参
            	ecdescription:'',
            	rdsDescription:'',
                //EC2优化建议 添加
            	selection: [],
                instanceModal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                isDisable: true,
                columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('MCM.reportConfiguration.instanceName'),
                    key: 'resourceName'
                },
                {
                    title: this.$t('MCM.reportConfiguration.instanceType'),
                    key: 'resourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.cpuUtilization'),
                    key: 'cpuUtilization'
                },
                {
                    title: this.$t('MCM.reportConfiguration.memoryUtilization'),
                    key: 'memoryUtilization'
                },
                {
                    title: this.$t('MCM.reportConfiguration.optimizeSuggestion'),
                    key: 'optimizeSuggestion'
                }],
                newQueryInstance:[],
                //EC2优化建议 删除
                name:'',
                modal_loading: false,
                instanceDelModal:false,
                isDisableDelete: false,
                //EC2优化建议
            	instanceLoading:false,
                instance: [
                {
                    title: this.$t('MCM.reportConfiguration.instanceName'),
                    key: 'resourceName'
                },
                {
                    title: this.$t('MCM.reportConfiguration.instanceType'),
                    key: 'resourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.cpuUtilization'),
                    key: 'cpuUtilization'
                },
                {
                    title: this.$t('MCM.reportConfiguration.memoryUtilization'),
                    key: 'memoryUtilization'
                },
                {
                    title: this.$t('MCM.reportConfiguration.optimizeSuggestion'),
                    key: 'optimizeSuggestion'
                },
                {
                	title: this.$t('common.operation'),
                	slot:'delete'
                }],
                newInstanceData:[],
                instanceDate:[],
                queryInstanceData: [],
                //RDS优化建议 添加
            	selectionDatabase: [],
                databaseModal: false,
                databaseModalLoading: true,
                databaseLoadingAdd: false,
                databaseAddloading:false,
                databaseIsDisable: true,
                databaseColumns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('MCM.reportConfiguration.databaseName'),
                    key: 'resourceName'
                },
                {
                    title: this.$t('MCM.reportConfiguration.databaseInstanceType'),
                    key: 'resourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.cpuUtilization'),
                    key: 'cpuUtilization'
                },
                {
                    title: this.$t('MCM.reportConfiguration.freememory'),
                    key: 'freememory'
                },
                {
                    title: this.$t('MCM.reportConfiguration.freeDisk'),
                    key: 'freeDisk'
                },
                {
                    title: this.$t('MCM.reportConfiguration.optimizeSuggestion'),
                    key: 'optimizeSuggestion'
                }],
                newQueryDatabase:[],
                //RDS优化建议 删除
                databaseName:'',
                databaseDelLoading: false,
                databaseDelModal:false,
                isDisableDatabase: false,
                //RDS优化建议
            	databaseLoading:false,
                database: [
                {
                    title: this.$t('MCM.reportConfiguration.databaseName'),
                    key: 'resourceName'
                },
                {
                    title: this.$t('MCM.reportConfiguration.databaseInstanceType'),
                    key: 'resourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.cpuUtilization'),
                    key: 'cpuUtilization'
                },
                {
                    title: this.$t('MCM.reportConfiguration.freememory'),
                    key: 'freememory'
                },
                {
                    title: this.$t('MCM.reportConfiguration.freeDisk'),
                    key: 'freeDisk'
                },
                {
                    title: this.$t('MCM.reportConfiguration.optimizeSuggestion'),
                    key: 'optimizeSuggestion'
                },
                {
                	title: this.$t('common.operation'),
                	slot:'delete'
                }],
                newDatabaseDate:[],
                databaseDate:[],
                queryDatabaseData: [],
                //降级前后花费对比 添加
            	selectionCostComparison: [],
                costComparisonModal: false,
                costComparisonModalLoading: true,
                costComparisonLoadingAdd: false,
                costComparisonAddloading:false,
                costComparisonIsDisable: true,
                costComparisonColumns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('MCM.reportConfiguration.instanceName'),
                    key: 'resourceName'
                },
                {
                    title: this.$t('MCM.reportConfiguration.optimizeType'),
                    key: 'optimizeType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.resourceBefore'),
                    key: 'resourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.resourceAfter'),
                    key: 'optimizeResourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.unitPriceBefore'),
                    key: 'unitPriceBefore'
                },
                {
                    title: this.$t('MCM.reportConfiguration.unitPriceAfter'),
                    key: 'unitPriceAfter'
                },
                {
                    title: this.$t('MCM.reportConfiguration.saveCost'),
                    key: 'saveCost'
                }],
                newQueryCostComparison:[],
                //降级前后花费对比 删除
                costComparisonName:'',
                costComparisonDelLoading: false,
                costComparisonDelModal:false,
                isDisableCostComparison: false,
                //降级前后花费对比
            	costComparisonLoading:false,
                costComparison: [
                {
                    title: this.$t('MCM.reportConfiguration.instanceName'),
                    key: 'resourceName'
                },
                {
                    title: this.$t('MCM.reportConfiguration.optimizeType'),
                    key: 'optimizeType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.resourceBefore'),
                    key: 'resourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.resourceAfter'),
                    key: 'optimizeResourceType'
                },
                {
                    title: this.$t('MCM.reportConfiguration.unitPriceBefore'),
                    key: 'unitPriceBefore'
                },
                {
                    title: this.$t('MCM.reportConfiguration.unitPriceAfter'),
                    key: 'unitPriceAfter'
                },
                {
                    title: this.$t('MCM.reportConfiguration.saveCost'),
                    key: 'saveCost'
                },
                {
                	title: this.$t('common.operation'),
                	slot:'delete'
                }],
                costComparisonDate:[],
                queryCostComparisonData: []
            }
        },
        beforeCreate: function() {
            resourceOptimizationVue = this
        },
        mounted () {
            resourceOptimizationVue.queryById();
            resourceOptimizationVue.selectReportOptimizeListInstance();
            resourceOptimizationVue.selectReportOptimizeListDatabase();
            resourceOptimizationVue.selectReportOptimizeListComparison();
        },
        created(){
            // 初始化参数
            this.accountIdList=JSON.parse(this.$route.query.accountIdList);
            this.reportId=Number(this.$route.query.reportId);
            this.companyId=Number(this.$route.query.companyId);
            this.reportDate=this.$route.query.reportDate;
        },
        methods: {
             // 查询填写原因
            queryById:function(){
                this.$api.report.queryById("id",this.reportId)
                .then(res => {
                    this.ecdescription=res.data.ec2OptimizeSuggestion;
                    this.rdsDescription=res.data.rdsOptimizeSuggestion;
                })
            },
             // 更新实例优化建议
            updateInstanceOptimizeSuggestion:function(){
                this.$api.report.updateInstanceOptimizeSuggestion({
                    "id":this.reportId,
                    "instanceOptimizeSuggestion":this.ecdescription
                })
                .then(res => {
                    this.$Message.success(this.$t('MCM.msg.updateSuccessExclam'));
                })
            },
             // 更新数据库优化建议
            updateDatabaseOptimizeSuggestion:function(){
                this.$api.report.updateDatabaseOptimizeSuggestion({
                    "id":this.reportId,
                    "databaseOptimizeSuggestion":this.rdsDescription
                })
                .then(res => {
                    this.$Message.success(this.$t('MCM.msg.updateSuccessExclam'));
                })
            },
        	/*****************EC2优化建议*************************************/
        	// 表格
            selectReportOptimizeListInstance:function(){
                this.instanceLoading = true;
                this.$api.reportOptimize.selectReportOptimizeList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.instanceDate=[];
                    this.newInstanceData = res.data;
                    for(var i=0;i<this.newInstanceData.length;i++){
                        if(this.newInstanceData[i].type==0){
                            this.instanceDate.push(this.newInstanceData[i]);
                        }
                    }
                    this.instanceLoading = false;
                })
            },
            // 查询EC2优化建议
            selectOptimizeListInstance:function(){
                this.instanceModal=true;
                this.loading=true;
                this.$api.reportOptimize.selectOptimizeList({
                    "reportId": this.reportId,
                    "type": 0
                })
                .then(res => {
                    this.queryInstanceData = res.data;
                    this.loading = false;
                })
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryInstance = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var NewQueryInstanceCopy = new Object();
                    NewQueryInstanceCopy.reportId = this.selection[i].reportId;
                    NewQueryInstanceCopy.resourceName = this.selection[i].resourceName;
                    NewQueryInstanceCopy.resourceId = this.selection[i].reportId;
                    NewQueryInstanceCopy.resourceType = this.selection[i].resourceType;
                    NewQueryInstanceCopy.optimizeResourceType = this.selection[i].optimizeResourceType;
                    NewQueryInstanceCopy.type = 0;
                    NewQueryInstanceCopy.optimizeType = this.selection[i].optimizeType;
                    NewQueryInstanceCopy.cpuUtilization = this.selection[i].cpuUtilization;
                    NewQueryInstanceCopy.memoryUtilization = this.selection[i].memoryUtilization;
                    NewQueryInstanceCopy.freememory = this.selection[i].freememory;
                    NewQueryInstanceCopy.freeDisk = this.selection[i].freeDisk;
                    NewQueryInstanceCopy.unitPriceBefore = this.selection[i].unitPriceBefore;
                    NewQueryInstanceCopy.unitPriceAfter = this.selection[i].unitPriceAfter;
                    NewQueryInstanceCopy.saveCost = this.selection[i].saveCost;
                    NewQueryInstanceCopy.optimizeSuggestion = this.selection[i].optimizeSuggestion;
                    this.newQueryInstance.push(NewQueryInstanceCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryInstance.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 添加
            handleSubmit: function () {
                this.addloading=true;
                this.$api.reportOptimize.addReportOptimize({
                    "reportId": this.reportId,
                    "reportOptimizeDTOList":this.newQueryInstance
                }).then(res => {
                    setTimeout(() => {
                        resourceOptimizationVue.selectReportOptimizeListInstance();
                        resourceOptimizationVue.selectReportOptimizeListDatabase();
                        resourceOptimizationVue.selectReportOptimizeListComparison();
                        this.modalLoading = false;
                        this.$nextTick(() => {
                            this.modalLoading = true;
                        });
                        this.$Message.success(this.$t('common.addSuccess'));
                        this.queryInstanceData=[];
                        this.newQueryInstance=[];
                        this.instanceModal = false;
                        this.isDisable = true;
                        this.addloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancel: function () {
                this.addloading=false;
                this.isDisable = true;
                this.instanceModal = false;
                this.queryInstanceData=[];
                this.newQueryInstance=[];
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.name=this.instanceDate[index].name;
            },
            removeInstance: function(){
                this.isDisableDelete = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportOptimize.deleteReportOptimize({"id":this.instanceDate[lineIndex].id})
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        resourceOptimizationVue.selectReportOptimizeListInstance();
                        resourceOptimizationVue.selectReportOptimizeListDatabase();
                        resourceOptimizationVue.selectReportOptimizeListComparison();
                        this.isDisableDelete = false;
                        this.modal_loading = false;
                        this.instanceDelModal = false;
                        this.$Message.success(this.$t('common.deleteSuccess'));
                    }, 1000);
                })
            },
            /*****************RDS优化建议************************************************/
            // 表格
            selectReportOptimizeListDatabase:function(){
                this.databaseLoading = true;
                this.$api.reportOptimize.selectReportOptimizeList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.databaseDate=[];
                    this.newDatabaseDate = res.data;
                    for(var i=0;i<this.newDatabaseDate.length;i++){
                        if(this.newDatabaseDate[i].type==1){
                            this.databaseDate.push(this.newDatabaseDate[i]);
                        }
                    }
                    this.databaseLoading = false;
                })
            },
            // 查询RDS优化建议
            selectOptimizeListRDS:function(){
                this.databaseModal=true;
                this.databaseLoadingAdd=true;
                this.$api.reportOptimize.selectOptimizeList({
                    "reportId": this.reportId,
                    "type": 1
                })
                .then(res => {
                    this.queryDatabaseData = res.data;
                    this.databaseLoadingAdd = false;
                })
            },
            // 当前选择checkbox
            getSelectionDatabase: function (selection) {
                this.selectionDatabase = selection;
                // 清空数组
                this.newQueryDatabase = [];
                for (var i = 0; i < this.selectionDatabase.length; i++) {
                    var NewQueryDatabaseCopy = new Object();
                    NewQueryDatabaseCopy.reportId = this.selectionDatabase[i].reportId;
                    NewQueryDatabaseCopy.resourceName = this.selectionDatabase[i].resourceName;
                    NewQueryDatabaseCopy.resourceId = this.selectionDatabase[i].reportId;
                    NewQueryDatabaseCopy.resourceType = this.selectionDatabase[i].resourceType;
                    NewQueryDatabaseCopy.optimizeResourceType = this.selectionDatabase[i].optimizeResourceType;
                    NewQueryDatabaseCopy.type = 1;
                    NewQueryDatabaseCopy.optimizeType = this.selectionDatabase[i].optimizeType;
                    NewQueryDatabaseCopy.cpuUtilization = this.selectionDatabase[i].cpuUtilization;
                    NewQueryDatabaseCopy.memoryUtilization = this.selectionDatabase[i].memoryUtilization;
                    NewQueryDatabaseCopy.freememory = this.selectionDatabase[i].freememory;
                    NewQueryDatabaseCopy.freeDisk = this.selectionDatabase[i].freeDisk;
                    NewQueryDatabaseCopy.unitPriceBefore = this.selectionDatabase[i].unitPriceBefore;
                    NewQueryDatabaseCopy.unitPriceAfter = this.selectionDatabase[i].unitPriceAfter;
                    NewQueryDatabaseCopy.saveCost = this.selectionDatabase[i].saveCost;
                    NewQueryDatabaseCopy.optimizeSuggestion = this.selectionDatabase[i].optimizeSuggestion;
                    this.newQueryDatabase.push(NewQueryDatabaseCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryDatabase.length == 0) {
                    this.databaseIsDisable = true;
                } else {
                    this.databaseIsDisable = false;
                }
            },
            // 添加
            databaseHandleSubmit: function () {
                this.databaseAddloading=true;
                this.$api.reportOptimize.addReportOptimize({
                    "reportId": this.reportId,
                    "reportOptimizeDTOList":this.newQueryDatabase
                }).then(res => {
                    setTimeout(() => {
                        resourceOptimizationVue.selectReportOptimizeListInstance();
                        resourceOptimizationVue.selectReportOptimizeListDatabase();
                        resourceOptimizationVue.selectReportOptimizeListComparison();
                        this.databaseModalLoading = false;
                        this.$nextTick(() => {
                            this.databaseModalLoading = true;
                        });
                        this.$Message.success(this.$t('common.addSuccess'));
                        this.queryDatabaseData=[];
                        this.newQueryDatabase=[];
                        this.databaseModal = false;
                        this.databaseIsDisable = true;
                        this.databaseAddloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancelDatabase: function () {
                this.databaseAddloading=false;
                this.databaseIsDisable = true;
                this.databaseModal = false;
                this.queryDatabaseData=[];
                this.newQueryDatabase=[];
            },
            // 删除
            /****************************************************/
            doDeleteDatabase: function(index){
                this.lineIndex=index;
                this.databaseName=this.databaseDate[index].name;
            },
            removeDatabase: function(){
                this.isDisableDatabase = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportOptimize.deleteReportOptimize({"id":this.databaseDate[lineIndex].id})
                .then(res => {
                    this.databaseDelLoading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        resourceOptimizationVue.selectReportOptimizeListInstance();
                        resourceOptimizationVue.selectReportOptimizeListDatabase();
                        resourceOptimizationVue.selectReportOptimizeListComparison();
                        this.isDisableDatabase = false;
                        this.databaseDelLoading = false;
                        this.databaseDelModal = false;
                        this.$Message.success(this.$t('common.deleteSuccess'));
                    }, 1000);
                })
            },
            /*****************降级前后花费对比************************************************/
            // 表格
            selectReportOptimizeListComparison:function(){
                this.costComparisonLoading = true;
                this.$api.reportOptimize.selectReportOptimizeList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.costComparisonDate = res.data;
                    for(var i=0;i<this.costComparisonDate.length;i++){
                        if(this.costComparisonDate[i].optimizeType==0){
                            this.costComparisonDate[i].optimizeType='升级';
                        }else if(this.costComparisonDate[i].optimizeType==1){
                            this.costComparisonDate[i].optimizeType='降级';
                        }
                    }
                    this.costComparisonLoading = false;
                })
            },
            // 查询RDS优化建议
            selectOptimizeListCostComparison:function(){
                this.costComparisonModal=true;
                this.costComparisonLoadingAdd=true;
                this.$api.reportOptimize.selectOptimizeList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.queryCostComparisonData = res.data;
                    for(var i=0;i<this.queryCostComparisonData.length;i++){
                        if(this.queryCostComparisonData[i].optimizeType==0){
                            this.queryCostComparisonData[i].optimizeType='升级';
                        }else if(this.queryCostComparisonData[i].optimizeType==1){
                            this.queryCostComparisonData[i].optimizeType='降级';
                        }
                    }
                    this.costComparisonLoadingAdd = false;
                })
            },
            // 转换优化类型
            getOptimizeType:function(optimizeTypeStr){
                for(var i=0;i<this.optimizeTypeList.length;i++){
                    if(optimizeTypeStr==this.optimizeTypeList[i]){
                        return i;
                    }
                }
                return -1;
            },
            // 当前选择checkbox
            getSelectionCostComparison: function (selection) {
                this.selectionCostComparison = selection;
                // 清空数组
                this.newQueryCostComparison = [];
                for (var i = 0; i < this.selectionCostComparison.length; i++) {
                    var optimizeType=this.getOptimizeType(this.selectionCostComparison[i].optimizeType);
                    var NewQueryCostComparisonCopy = new Object();
                    NewQueryCostComparisonCopy.reportId = this.selectionCostComparison[i].reportId;
                    NewQueryCostComparisonCopy.resourceName = this.selectionCostComparison[i].resourceName;
                    NewQueryCostComparisonCopy.resourceId = this.selectionCostComparison[i].reportId;
                    NewQueryCostComparisonCopy.resourceType = this.selectionCostComparison[i].resourceType;
                    NewQueryCostComparisonCopy.optimizeResourceType = this.selectionCostComparison[i].optimizeResourceType;
                    NewQueryCostComparisonCopy.type = this.selectionCostComparison[i].type;
                    NewQueryCostComparisonCopy.optimizeType = optimizeType;
                    NewQueryCostComparisonCopy.cpuUtilization = this.selectionCostComparison[i].cpuUtilization;
                    NewQueryCostComparisonCopy.memoryUtilization = this.selectionCostComparison[i].memoryUtilization;
                    NewQueryCostComparisonCopy.freememory = this.selectionCostComparison[i].freememory;
                    NewQueryCostComparisonCopy.freeDisk = this.selectionCostComparison[i].freeDisk;
                    NewQueryCostComparisonCopy.unitPriceBefore = this.selectionCostComparison[i].unitPriceBefore;
                    NewQueryCostComparisonCopy.unitPriceAfter = this.selectionCostComparison[i].unitPriceAfter;
                    NewQueryCostComparisonCopy.saveCost = this.selectionCostComparison[i].saveCost;
                    NewQueryCostComparisonCopy.optimizeSuggestion = this.selectionCostComparison[i].optimizeSuggestion;
                    this.newQueryCostComparison.push(NewQueryCostComparisonCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryCostComparison.length == 0) {
                    this.costComparisonIsDisable = true;
                } else {
                    this.costComparisonIsDisable = false;
                }
            },
            // 添加
            costComparisonHandleSubmit: function () {
                this.costComparisonAddloading=true;
                this.$api.reportOptimize.addReportOptimize({
                    "reportId": this.reportId,
                    "reportOptimizeDTOList":this.newQueryCostComparison
                }).then(res => {
                    setTimeout(() => {
                        resourceOptimizationVue.selectReportOptimizeListInstance();
                        resourceOptimizationVue.selectReportOptimizeListDatabase();
                        resourceOptimizationVue.selectReportOptimizeListComparison();
                        this.costComparisonModalLoading = false;
                        this.$nextTick(() => {
                            this.costComparisonModalLoading = true;
                        });
                        this.$Message.success(this.$t('common.addSuccess'));
                        this.queryCostComparisonData=[];
                        this.newQueryCostComparison=[];
                        this.costComparisonModal = false;
                        this.costComparisonIsDisable = true;
                        this.costComparisonAddloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancelCostComparison: function () {
                this.costComparisonAddloading=false;
                this.costComparisonIsDisable = true;
                this.costComparisonModal = false;
                this.queryCostComparisonData=[];
                this.newQueryCostComparison=[];
            },
            // 删除
            /****************************************************/
            doDeleteCostComparison: function(index){
                this.lineIndex=index;
                this.costComparisonName=this.costComparisonDate[index].name;
            },
            removeCostComparison: function(){
                this.isDisableCostComparison = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportOptimize.deleteReportOptimize({"id":this.costComparisonDate[lineIndex].id})
                .then(res => {
                    this.costComparisonDelLoading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        resourceOptimizationVue.selectReportOptimizeListInstance();
                        resourceOptimizationVue.selectReportOptimizeListDatabase();
                        resourceOptimizationVue.selectReportOptimizeListComparison();
                        this.isDisableCostComparison = false;
                        this.costComparisonDelLoading = false;
                        this.costComparisonDelModal = false;
                        this.$Message.success(this.$t('common.deleteSuccess'));
                    }, 1000);
                })
            }
        }
    }
</script>

<style scoped>
    .title
    {
        font-size:14px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 30px;
    }
	/* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        float:left;
        color:#000;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/report_configuration/ResourceOptimization.vue